import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
// import Skeleton from '@material-ui/lab/Skeleton';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import axiosInstance, { FACULTY_API_URL } from '../constatns';
import swal from 'sweetalert';
import {
  // trySpeakerId,
  tryCvSpeakerId,
  InvirtedSpeakers,
} from './trySpeakerId';
import './InternationalSpeakers.css';

import Card from '@mui/material/Card';

import Stack from '@mui/material/Stack';
// import Preparing from '../components/Preparing';

import { SpeakerData } from './SpeakerData';

const styles = (theme) => ({
  chips: {
    color: 'white',
    width: '100%',
    height: '48px',
    borderRadius: '0',
    marginBottom: '13px',
    background: '#376092',
    fontSize: '24px',
  },
  noImgBox: {
    minWidth: '147px',
    maxWidth: '147px',
    minHeight: '180px',
    border: '1px solid rgba(38, 38, 38, 0.05)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    '& > img': {
      width: '70%',
      maxWidth: '70%',
      minHeight: 'auto',
    },
  },
});

class InternationalSpeakers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakerList: [],
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  componentDidMount() {
    this.getSpeakerList();
  }

  getSpeakerList = () => {
    axiosInstance.get(`${FACULTY_API_URL}/speaker/prs`).then((res) => {
      let data = res.data;
      // console.log(res, 'res');

      data.sort(function (a, b) {
        return parseInt(a.no) > parseInt(b.no) ? 1 : -1;
      });

      let _data = data.filter((data) => {
        return data.country !== 'Korea';
      });

      this.setState({ speakerList: _data });
    });
  };

  openCvfile(id, cvfile) {
    if (tryCvSpeakerId.includes(id)) {
      window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/program/speakers/${cvfile}`, '_blank');
    } else {
      swal('', 'To be updated.');
    }
  }
  openSpeakerCvfile(name, noCv) {
    if (noCv !== true) {
      window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/program/speakers/cv/${name}_CV.pdf`, '_blank');
    } else {
      swal('', 'To be updated.');
    }
  }
  openMainCvfile(cvfile) {
    window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/program/speakers/${cvfile}`, '_blank');
  }

  renderSpeakers(data) {
    return (
      <Grid container justifyContent="center" style={{ width: 1200 }}>
        {data.map(
          (speaker) => (
            // navigator.userAgent.match(/Android/i) ||
            // navigator.userAgent.match(/mobile/i) ||
            // navigator.userAgent.match(/iPhone/i) ||
            // navigator.userAgent.match(/iPod/i) ? (
            //   ''
            // ) : (
            <div key={`index_${speaker.name}`} style={{ width: 400, height: 200 }}>
              <Grid
                container
                style={{
                  width: 380,
                  height: 180,
                  backgroundColor: 'rgba(95,130,119,0.1)',
                  borderRadius: 5,
                  margin: 10,
                }}
              >
                <Grid
                  style={{
                    width: 140,
                    height: 180,
                  }}
                >
                  {speaker.noPic !== true ? (
                    <img
                      src={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/program/speakers/pic/${speaker.name}.png`}
                      alt={speaker.name}
                      style={{ width: 137, height: 176, borderRadius: 5 }}
                      // className={`img_${speaker.id}`}
                    />
                  ) : (
                    <img src={'images/PRS2022/no_img_2022.png'} alt="noImg" style={{ width: 137, height: 176, borderRadius: 5 }} />
                  )}
                </Grid>
                <Grid style={{ width: 240, padding: '0 10px', position: 'relative' }}>
                  <Grid item xs={12} style={{ paddingTop: 16 }}>
                    <Typography style={{ color: '#252525', fontWeight: 900, fontSize: 18 }}>{speaker.name.replace('^', '')}</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ paddingTop: 8 }}>
                    <Typography
                      style={{
                        color: '#555555',
                        fontStyle: 'italic',
                        fontSize: speaker.longTerm && speaker.longTerm == true ? 15 : 16,
                        wordBreak: 'keep-all',
                      }}
                      dangerouslySetInnerHTML={{ __html: speaker.affiliation }}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ paddingTop: 8 }}>
                    <Typography style={{ color: '#000000', fontStyle: 'italic', fontSize: 16 }}>{speaker.country}</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ position: 'absolute', bottom: 10 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      disableElevation
                      onClick={() => this.openSpeakerCvfile(speaker.name, speaker.noCv)}
                    >
                      CV
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          ),
          // ),
        )}
      </Grid>
    );
  }

  renderMainSpeakers(data) {
    return (
      // <Grid item xs={12} sm={6} md={6} lg={4} container justifyContent="center">
      <Grid item xs={12} container justifyContent="center">
        {data.map((speaker, idx) => (
          <Card
            key={`international-speaker-${idx}`}
            style={{
              width: 320,
              // margin: '16px 0',
              margin: 16,
              backgroundColor: 'rgba(55,96,146,0.05)',
              // backgroundImage: `url('${EVENT_IMG}/speaker_bg.png')`,
              // backgroundPosition: 'center center',
            }}
          >
            {/* <Card style={{ width: 320, margin: '16px 0', backgroundColor: '#fff' }}> */}
            <Stack spacing={1} justifyContent="center" style={{ padding: '16px 0' }} direction="column">
              <Grid container justifyContent="center" alignItems="center">
                <img
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/program/${speaker.image}`}
                  alt={speaker.name}
                  style={{ height: 176, width: 137, borderRadius: 5 }}
                  className={`img_${speaker.id}`}
                />
              </Grid>
              <Grid container justifyContent="center">
                <Typography style={{ fontWeight: 900, fontSize: 22 }}>{speaker.name.replace('^', '')}</Typography>
              </Grid>
              <Grid container justifyContent="center">
                <Typography dangerouslySetInnerHTML={{ __html: speaker.affiliation }} style={{ color: '#555555', fontSize: 20 }} />
              </Grid>
              <Grid container justifyContent="center">
                <Typography style={{ color: '#000000', fontFamily: 'Roboto-Regular', fontStyle: 'italic', fontSize: 20 }}>
                  {speaker.country}
                </Typography>
              </Grid>
              <Grid container justifyContent="center">
                <Button
                  variant="contained"
                  color="primary"
                  // size="small"
                  disableElevation
                  onClick={() => this.openMainCvfile(speaker.cvfile)}
                  // onClick={() => swal('', 'To Be updated.', 'info')}
                  style={{ width: 150, fontWeight: 900 }}
                >
                  CV
                </Button>
              </Grid>
            </Stack>
          </Card>
        ))}
      </Grid>
    );
  }

  render() {
    // const { classes } = this.props;
    // const { speakerList } = this.state;
    return (
      <>
        {/* <div style={{ backgroundImage: `url('${EVENT_IMG}/speaker_bg.png')`, width: '100%', backgroundPosition: 'center center' }}> */}
        {/* <Chip className={classes.chips} label="Main Invited Speakers" /> */}
        <Grid
          item
          xs={12}
          style={{
            // borderBottom: '2px solid #376092',
            padding: 10,
            backgroundImage: 'radial-gradient( circle farthest-corner at 22.4% 21.7%, rgba(4,189,228,1) 0%, #376092 100.2%)',
          }}
        >
          <Typography style={{ fontSize: 26, fontWeight: 900, textAlign: 'center', color: '#fff' }}>Main Invited Speakers</Typography>
        </Grid>
        <Grid container>{this.renderMainSpeakers(InvirtedSpeakers)}</Grid>
        {/* <Chip className={classes.chips} label="Speakers" /> */}
        <Grid
          item
          xs={12}
          style={{
            // borderBottom: '2px solid #5f8277',
            backgroundImage: 'linear-gradient(to right, #00b09b, #aacb3c)',
            textAlign: 'center',
            margin: '16px 0',
            padding: 10,
          }}
        >
          <Typography style={{ fontSize: 26, fontWeight: 900, color: '#fff' }}>Speakers</Typography>
        </Grid>
        {/* 
        <Grid item xs={12}>
          <Preparing />
        </Grid> */}
        <Grid container justifyContent="center">
          {this.renderSpeakers(SpeakerData)}
        </Grid>
      </>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(InternationalSpeakers));
